import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import { useAppDispatch, useAppSelector } from '../../../hooks/index';
import { Afr, getSelectedAfr } from '../../../redux/AfrSlice';
import { loadEntity } from '../../../redux/EntitySlice';
import { selectAuthorizedEntities, selectUser, selectUserRole, UserRoleEnum } from '../../../redux/UserSlice';
import NavigationPanelItem from '../../core/NavigationPanelItem';
import AfrNavigator from '../../feature/AfrNavigator';
import AfrSelector from '../../feature/AfrSelector';
import EntitySelector from '../../feature/EntitySelector';
import TaxonomyVersionSelector from '../../feature/TaxonomyVersionSelector';
import { getTaxonomyType } from '../../../redux/MiscSlice';
import { TaxonomyTypeEnum } from '../../../redux/TaxonomyVersionSlice';
import ReportNavigator from '../../feature/ReportNavigator';



const NavigationPanel = () => {
    var location = useLocation();
    const dispatch = useAppDispatch();
    const selected: Afr | null = useAppSelector(getSelectedAfr);
    const user = useAppSelector(selectUser);
    const userRoleSelector = useAppSelector(selectUserRole);
    const authorizedEntitiesSelector = useAppSelector(selectAuthorizedEntities);
    const taxonomyType: TaxonomyTypeEnum | null = useAppSelector(getTaxonomyType);

    const [greaterThanOneEntityAuthorization, setGreaterThanOneEntitAuthorization] = React.useState<boolean>(true);

    const enableDepartmentSelector =
        location.pathname === "/DepartmentStaffManagement";

    const enableEntitySelector =
        location.pathname === "/EntityAFRManagement" ||
        location.pathname === "/EntityAFRManagementA" ||
        (taxonomyType === 'AFR' &&
        (location.pathname === "/EntityMenu" ||
        location.pathname === "/EntityManagement" ||
        location.pathname === "/AdminEntityManagement" ||
        location.pathname === "/EntityManagementA" ||
        location.pathname === "/AfrSummary" ||
        location.pathname === "/AfrDataImport" ||
        location.pathname === "/BalanceSheet" ||
        location.pathname === "/Revenues" ||
        location.pathname === "/Expenditures" ||
        location.pathname === "/LongTermDebt" ||
        location.pathname === "/AffiliateReporting" ||
        location.pathname === "/Audit" ||
        location.pathname === "/Certification" ||
        location.pathname === "/AfrReports" ||
        location.pathname === "/AfrSummaryA" ||
        location.pathname === "/AfrDataImportA" ||
        location.pathname === "/BalanceSheetA" ||
        location.pathname === "/RevenuesA" ||
        location.pathname === "/ExpendituresA" ||
        location.pathname === "/AccountsByGovernmentalA" ||
        location.pathname === "/AccountsByProprietaryA" ||
        location.pathname === "/AccountsByFiduciaryA" ||
        location.pathname === "/AccountsByComponentUnitsA" ||
        location.pathname === "/AccountsByGovernmental" ||
        location.pathname === "/AccountsByProprietary" ||
        location.pathname === "/AccountsByFiduciary" ||
        location.pathname === "/AccountsByComponentUnits" ||
        location.pathname === "/LongTermDebtA" ||
        location.pathname === "/AffiliateReportingA" ||
        location.pathname === "/AuditA" ||
        location.pathname === "/CertificationA" ||
        location.pathname === "/AfrReportsA" ||
        location.pathname === "/AfrDataA" ||
        location.pathname === "/AfrData" ||
        location.pathname === "/AffiliatedEntitiesA" ||
        location.pathname === "/AffiliatedEntities" ||
        location.pathname === "/ErrorsA" ||
        location.pathname === "/Errors"));

    const enable939EntitySelector =
        location.pathname === "/939CourtReporting" ||
        (taxonomyType === 'COURT_REPORTING_939' &&
        (location.pathname === "/EntityMenu" ||
        location.pathname === "/EntityManagement" ||
        location.pathname === "/AdminEntityManagement" ||
        location.pathname === "/EntityManagementA" ||
        location.pathname === "/CourtReporting939Admin" ||
        location.pathname === "/CourtReporting939AdminA" ||
        location.pathname === "/CourtReporting939CIA" ||
        location.pathname === "/CourtReporting939CI" ||
        location.pathname === "/CourtReporting939LAPA" ||
        location.pathname === "/CourtReporting939LAP" ||
        location.pathname === "/CourtReporting939LLA" ||
        location.pathname === "/CourtReporting939LL" ||
        location.pathname === "/CourtReporting939JAPA" ||
        location.pathname === "/CourtReporting939JAP" ||
        location.pathname === "/CourtReporting939Summary" ||
        location.pathname === "/CourtReporting939SummaryA" ||
        location.pathname === "/CourtReporting939ImportExport" ||
        location.pathname === "/CourtReporting939ImportExportA" ||
        location.pathname === "/CR939ReportsA" ||
        location.pathname === "/CR939Reports" ||
        location.pathname === "/CR939ErrorsA" ||
        location.pathname === "/CR939Errors"));

    const enable29EntitySelector =
        location.pathname === "/29CourtReporting" ||
        (taxonomyType === 'COURT_REPORTING_29' &&
            (location.pathname === "/EntityMenu" ||
                location.pathname === "/EntityManagement" ||
                location.pathname === "/AdminEntityManagement" ||
                location.pathname === "/EntityManagementA" ||
                location.pathname === "/CR29Admin" ||
                location.pathname === "/CR29AdminA" ||
                location.pathname === "/CR29DataA" ||
                location.pathname === "/CR29DataAA" ||
                location.pathname === "/CR29DataB" ||
                location.pathname === "/CR29DataBA" ||
                location.pathname === "/CR29DataC" ||
                location.pathname === "/CR29DataCA" ||
                location.pathname === "/CR29DataD" ||
                location.pathname === "/CR29DataDA" ||
                location.pathname === "/CR29DataE" ||
                location.pathname === "/CR29DataEA" ||
                location.pathname === "/CR29ImportExport" ||
                location.pathname === "/CR29ImportExportA" ||
                location.pathname === "/CR29CertificationA" ||
                location.pathname === "/CR29Certification" ||
                location.pathname === "/CR29ReportsA" ||
                location.pathname === "/CR29Reports" ||
                location.pathname === "/CR29ErrorsA" ||
                location.pathname === "/Instructions" ||
                location.pathname === "/InstructionsA" ||
                location.pathname === "/CR29Errors"));

    const enableAFRSelector =
        taxonomyType === 'AFR' && 
        (location.pathname === "/EntityAFRManagement" ||
        location.pathname === "/AdminAFRManagement" ||
        location.pathname === "/EntityAFRManagementA" ||
        location.pathname === "/AfrSummary" ||
        location.pathname === "/AfrDataImport" ||
        location.pathname === "/BalanceSheet" ||
        location.pathname === "/Revenues" ||
        location.pathname === "/Expenditures" ||
        location.pathname === "/LongTermDebt" ||
        location.pathname === "/AffiliateReporting" ||
        location.pathname === "/Audit" ||
        location.pathname === "/Certification" ||
        location.pathname === "/AfrReports" ||
        location.pathname === "/AfrSummaryA" ||
        location.pathname === "/AfrDataImportA" ||
        location.pathname === "/BalanceSheetA" ||
        location.pathname === "/RevenuesA" ||
        location.pathname === "/ExpendituresA" ||
        location.pathname === "/AccountsByGovernmentalA" ||
        location.pathname === "/AccountsByProprietaryA" ||
        location.pathname === "/AccountsByFiduciaryA" ||
        location.pathname === "/AccountsByComponentUnitsA" ||
        location.pathname === "/AccountsByGovernmental" ||
        location.pathname === "/AccountsByProprietary" ||
        location.pathname === "/AccountsByFiduciary" ||
        location.pathname === "/AccountsByComponentUnits" ||
        location.pathname === "/LongTermDebtA" ||
        location.pathname === "/AffiliateReportingA" ||
        location.pathname === "/AuditA" ||
        location.pathname === "/CertificationA" ||
        location.pathname === "/AfrReportsA" ||
        location.pathname === "/AfrDataA" ||
        location.pathname === "/AfrData" ||
        location.pathname === "/AffiliatedEntitiesA" ||
        location.pathname === "/AffiliatedEntities" ||
        location.pathname === "/ErrorsA" ||
        location.pathname === "/Errors");

    const enable939Selector =
        (location.pathname === "/939CourtReporting" ||
        (taxonomyType === 'COURT_REPORTING_939' &&
        (location.pathname === "/AdminAFRManagement" ||
        location.pathname === "/EntityAFRManagementA" ||
        location.pathname === "/AfrSummary" ||
        location.pathname === "/CourtReporting939Admin" ||
        location.pathname === "/CourtReporting939AdminA" ||
        location.pathname === "/CourtReporting939Summary" ||
        location.pathname === "/CourtReporting939SummaryA" ||
        location.pathname === "/CourtReporting939ImportExport" ||
        location.pathname === "/CourtReporting939ImportExportA" ||
        location.pathname === "/CourtReporting939CIA" ||
        location.pathname === "/CourtReporting939CI" ||
        location.pathname === "/CourtReporting939LAPA" ||
        location.pathname === "/CourtReporting939LAP" ||
        location.pathname === "/CourtReporting939LLA" ||
        location.pathname === "/CourtReporting939LL" ||
        location.pathname === "/CourtReporting939JAPA" ||
        location.pathname === "/CourtReporting939JAP" ||
        location.pathname === "/CR939ReportsA" ||
        location.pathname === "/CR939Reports" ||
        location.pathname === "/CourtReporting939ImportExportA" ||
        location.pathname === "/CR939ErrorsA" ||
        location.pathname === "/CR939Errors")));

    const enable29Selector =
        location.pathname === "/29CourtReporting" ||
        (taxonomyType === 'COURT_REPORTING_29' &&
            (location.pathname === "/EntityMenu" ||
                location.pathname === "/EntityManagement" ||
                location.pathname === "/AdminEntityManagement" ||
                location.pathname === "/EntityManagementA" ||
                location.pathname === "/CR29Admin" ||
                location.pathname === "/CR29AdminA" ||
                location.pathname === "/CR29DataA" ||
                location.pathname === "/CR29DataAA" ||
                location.pathname === "/CR29DataB" ||
                location.pathname === "/CR29DataBA" ||
                location.pathname === "/CR29DataC" ||
                location.pathname === "/CR29DataCA" ||
                location.pathname === "/CR29DataD" ||
                location.pathname === "/CR29DataDA" ||
                location.pathname === "/CR29DataE" ||
                location.pathname === "/CR29DataEA" ||
                location.pathname === "/CR29ImportExport" ||
                location.pathname === "/CR29ImportExportA" ||
                location.pathname === "/CR29CertificationA" ||
                location.pathname === "/CR29Certification" ||
                location.pathname === "/CR29ReportsA" ||
                location.pathname === "/CR29Reports" ||
                location.pathname === "/CR29ErrorsA" ||
                location.pathname === "/Instructions" ||
                location.pathname === "/InstructionsA" ||
                location.pathname === "/CR29Errors"));

    const enableAFRNavigator =
        selected && selected.taxonomyType === 'AFR' &&
        (location.pathname === "/EntityAFRManagement" ||
        location.pathname === "/AdminAFRManagement" ||
        location.pathname === "/EntityAFRManagementA" ||
        location.pathname === "/AfrSummary" ||
        location.pathname === "/AfrDataImport" ||
        location.pathname === "/BalanceSheet" ||
        location.pathname === "/Revenues" ||
        location.pathname === "/Expenditures" ||
        location.pathname === "/LongTermDebt" ||
        location.pathname === "/AffiliateReporting" ||
        location.pathname === "/Audit" ||
        location.pathname === "/Certification" ||
        location.pathname === "/AfrReports" ||
        location.pathname === "/AfrReportsA" ||
        location.pathname === "/AfrSummaryA" ||
        location.pathname === "/AfrDataImportA" ||
        location.pathname === "/BalanceSheetA" ||
        location.pathname === "/RevenuesA" ||
        location.pathname === "/ExpendituresA" ||
        location.pathname === "/AccountsByGovernmentalA" ||
        location.pathname === "/AccountsByProprietaryA" ||
        location.pathname === "/AccountsByFiduciaryA" ||
        location.pathname === "/AccountsByComponentUnitsA" ||
        location.pathname === "/AccountsByGovernmental" ||
        location.pathname === "/AccountsByProprietary" ||
        location.pathname === "/AccountsByFiduciary" ||
        location.pathname === "/AccountsByComponentUnits" ||
        location.pathname === "/LongTermDebtA" ||
        location.pathname === "/AffiliateReportingA" ||
        location.pathname === "/AuditA" ||
        location.pathname === "/CertificationA" ||
        location.pathname === "/AfrDataA"  ||
        location.pathname === "/AfrData" ||
        location.pathname === "/AffiliatedEntitiesA" ||
        location.pathname === "/AffiliatedEntities" ||
        location.pathname === "/ErrorsA" ||
        location.pathname === "/Errors" 
        );

    const enable939Navigator =
        selected && selected.taxonomyType === 'COURT_REPORTING_939' &&
        (location.pathname === "/939CourtReporting" ||
            location.pathname === "/CourtReporting939Admin" ||
            location.pathname === "/CourtReporting939AdminA" ||
            location.pathname === "/CourtReporting939Summary" ||
            location.pathname === "/CourtReporting939SummaryA" ||
            location.pathname === "/CourtReporting939ImportExport" ||
            location.pathname === "/CourtReporting939ImportExportA" ||
            location.pathname === "/CourtReporting939CIA" ||
            location.pathname === "/CourtReporting939CI" ||
            location.pathname === "/CourtReporting939LAPA" ||
            location.pathname === "/CourtReporting939LAP" ||
            location.pathname === "/CourtReporting939LLA" ||
            location.pathname === "/CourtReporting939LL" ||
            location.pathname === "/CourtReporting939JAPA" ||
            location.pathname === "/CourtReporting939JAP" ||
            location.pathname === "/AdminAFRManagement" ||
            location.pathname === "/EntityAFRManagementA" ||
            location.pathname === "/CourtReporting939ImportExportA" ||
            location.pathname === "/CR939ReportsA" ||
            location.pathname === "/CR939Reports" ||
            location.pathname === "/CR939ErrorsA" ||
            location.pathname === "/CR939Errors"
        );

    const enable29Navigator =
        location.pathname === "/29CourtReporting" ||
        (taxonomyType === 'COURT_REPORTING_29' &&
            (location.pathname === "/EntityMenu" ||
                location.pathname === "/EntityManagement" ||
                location.pathname === "/AdminEntityManagement" ||
                location.pathname === "/EntityManagementA" ||
                location.pathname === "/CR29Admin" ||
                location.pathname === "/CR29AdminA" ||
                location.pathname === "/CR29DataA" ||
                location.pathname === "/CR29DataAA" ||
                location.pathname === "/CR29DataB" ||
                location.pathname === "/CR29DataBA" ||
                location.pathname === "/CR29DataC" ||
                location.pathname === "/CR29DataCA" ||
                location.pathname === "/CR29DataD" ||
                location.pathname === "/CR29DataDA" ||
                location.pathname === "/CR29DataE" ||
                location.pathname === "/CR29DataEA" ||
                location.pathname === "/CR29ImportExport" ||
                location.pathname === "/CR29ImportExportA" ||
                location.pathname === "/CR29CertificationA" ||
                location.pathname === "/CR29Certification" ||
                location.pathname === "/CR29ReportsA" ||
                location.pathname === "/CR29Reports" ||
                location.pathname === "/CR29ErrorsA" ||
                location.pathname === "/InstructionsA" ||
                location.pathname === "/Instructions" ||
                location.pathname === "/CR29Errors"));


    const enableTaxonomySelector =
        (location.pathname === "/AccountCodeManagement" ||
            location.pathname === "/EntityManagementA" ||
            location.pathname === "/AuditFirmManagement");

    const enableTaxonomySelectorCR =
        (location.pathname === "/AccountCodeManagementCR");

    const enableReportNavigator =
        location.pathname === "/SystemReports";

    React.useEffect(() => {

        if (userRoleSelector && userRoleSelector == UserRoleEnum.EntityUser) {
            if (authorizedEntitiesSelector) {
                if (authorizedEntitiesSelector.length == 1) {
                    var entityCode = authorizedEntitiesSelector[0].code;
                    if (entityCode) {
                        setGreaterThanOneEntitAuthorization(false);
                    }                  
                }
            }
        }

    }, [user])

    return (
        <React.Fragment>
        {/*
           Attempting to consolidate this component proved challenging.  The use effect for the taxonomy selector did
           not initially force a rerender for the entity selector component, when visiting 939 routes.  I had to add 
           the location path as a dependency so that the use effect would trigger a rerender.  This makes  sense given
           the 939 component does not have the entity selector as a child component.  Overall the attempt was less
           performant than what was there because the location path changes when the user selects options from the 
           AFR navigator.  Again, what is present here (multiple selectors with different props) is more performant
           than a single consolidated component with hooks that change state.
        */}
            <Row hidden={greaterThanOneEntityAuthorization == false}>
                <Col>
                    <NavigationPanelItem
                        active={enableEntitySelector}
                        componentName="Entity Selector">
                        <EntitySelector selectorTitle="Choose Entity" taxonomyType={TaxonomyTypeEnum.AFR} />
                    </NavigationPanelItem>
                    <NavigationPanelItem
                        active={enable939EntitySelector}
                        componentName="County Selector">
                        <EntitySelector selectorTitle="Choose County" taxonomyType={TaxonomyTypeEnum.COURT_REPORTING_939} />
                    </NavigationPanelItem>
                    <NavigationPanelItem
                        active={enable29EntitySelector}
                        componentName="County Selector">
                        <EntitySelector selectorTitle="Choose County" taxonomyType={TaxonomyTypeEnum.COURT_REPORTING_29} />
                    </NavigationPanelItem>
                    <NavigationPanelItem
                        active={enableDepartmentSelector}
                        componentName="Department Selector">
                        <EntitySelector selectorTitle="Choose Department" taxonomyType={TaxonomyTypeEnum.DEPARTMENT} />
                    </NavigationPanelItem>
                </Col>
            </Row>

            <Row>
                <Col>
                    <NavigationPanelItem
                        active={enableAFRSelector}
                        componentName="Choose AFR">
                        <AfrSelector />
                    </NavigationPanelItem>
                    <NavigationPanelItem
                        active={enable939Selector}
                        componentName="Choose 939.185 Court Report">
                        <AfrSelector />
                    </NavigationPanelItem>
                    <NavigationPanelItem
                        active={enable29Selector}
                        componentName="Choose 29.0085 Court Report">
                        <AfrSelector />
                    </NavigationPanelItem>
                    <NavigationPanelItem
                        active={enableReportNavigator}
                        componentName="Choose Report Group">
                        <ReportNavigator />
                    </NavigationPanelItem>
                </Col>
            </Row>
            <Row>
                <Col>
                    <NavigationPanelItem
                        active={enableAFRNavigator}
                        componentName="Submission Process Tracker">
                        <AfrNavigator />
                    </NavigationPanelItem>
                    <NavigationPanelItem
                        active={enable939Navigator}
                        componentName="Court Report 939.185 Navigator">
                        <AfrNavigator />
                    </NavigationPanelItem>
                    <NavigationPanelItem
                        active={enable29Navigator}
                        componentName="Court Report 29.0085 Navigator">
                        <AfrNavigator />
                    </NavigationPanelItem>
                </Col>
            </Row>
            <Row>
                <Col>
                    <NavigationPanelItem
                        active={enableTaxonomySelector}
                        componentName="Taxonomy Version Selector">
                        <TaxonomyVersionSelector taxonomyType={TaxonomyTypeEnum.AFR} />
                    </NavigationPanelItem>
                    <NavigationPanelItem
                        active={enableTaxonomySelectorCR}
                        componentName="Court Reporting Taxonomy Version Selector">
                        <TaxonomyVersionSelector taxonomyType={TaxonomyTypeEnum.COURT_REPORTING} />
                    </NavigationPanelItem>
                </Col>
            </Row>
        </React.Fragment>
    );
}


export default NavigationPanel;